import { render, staticRenderFns } from "./SpareDettails.vue?vue&type=template&id=b974152e&"
import script from "./SpareDettails.vue?vue&type=script&lang=js&"
export * from "./SpareDettails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports